import { CareerLevel } from '../enums';

const careerLevelPatterns = {
	'Entry Level': ['fresh'],
	'Junior': ['junior'],
	'Mid-Level': ['m.?d.?level'],
	'Senior': ['senior'],
	'Team Lead': ['tech.*lead', 'team.*lead']
	// 'Manager': ['.*principal.*', '.*manager.*', 'cto']
};

const prepareAssocMap = assoc => {
	const result = {};
	Object.keys(assoc).forEach(mapTo => {
		assoc[mapTo].forEach(mapping => {
			result[mapping] = mapTo;
		});
	});
	return result;
};

export const extractSeniorityFromTitle = title => {
	const assocMap = prepareAssocMap(careerLevelPatterns);
	title = title.toLowerCase().replace('-', '');
	let extractedSeniority = undefined;
	let cleanedTitle = title;
	Object.keys(assocMap).forEach(word => {
		const regex = new RegExp(word, 'g');
		if (regex.test(title)) {
			extractedSeniority = assocMap[word];
			cleanedTitle = title.replace(regex, '').replace(' ', '');
		}
	});

	return { extractedSeniority, cleanedTitle };
};

export const extractSeniorityFromExp = exp => {
	if (exp >= 0 && exp < 1) return CareerLevel.ENTRY_LEVEL;
	else if (exp >= 1 && exp < 3) return CareerLevel.JUNIOR;
	else if (exp >= 3 && exp < 5) return CareerLevel.MIDLEVEL;
	else if (exp >= 5 && exp < 7) return CareerLevel.SENIOR;
	else if (exp >= 7 && exp < 10) return CareerLevel.TEAM_LEAD;
	else if (exp >= 10 && exp < 100) return CareerLevel.MANAGER;
};
